import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageOption, selectorList } from 'src/app/config/language.config';

@Component({
  selector: 'app-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
})
export class SelectorComponent implements OnInit {
  isOpen = false;
  languages = selectorList;
  selectedLanguage: LanguageOption;
  @Output() languageChange = new EventEmitter<any>();
  @Input() initLanguage: string;

  constructor() { }

  ngOnInit(): void {
    this.selectedLanguage =
      this.languages.find((x) => x.value === this.initLanguage) ||
      selectorList[0];
  }

  onSelect(language: LanguageOption): void {
    this.isOpen = false;
    if (language === this.selectedLanguage) {
      return;
    }
    this.selectedLanguage = language;
    this.languageChange.emit(language.value);
  }

  onClick(): void {
    this.isOpen = !this.isOpen;
  }
}
